import React from "react";

import Zone from "components/Tvendo/Sale/DataMaster/Zone/Zone";

export default function () {
  return (<Zone />);
}
